export default __webpack_public_path__ + "static/asraa-63809ee87cf13e444ea261d8ebf80cf5.png";